import { Col, QRCode, Row } from 'antd';
import Box from 'components/Box';
import Text from 'components/Text';
import { IInfoPrinterWaitingResData } from 'features/payment/services/types/ticket';
import React from 'react';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { maskPhone } from 'utils/formatPhone';
import storage from 'utils/sessionStorage';
import ic_group from './ic-group.svg';

type Props = {
  divRef?: React.RefObject<HTMLDivElement>;
  data: IInfoPrinterWaitingResData | null;
};

const ReceiptUI = ({ divRef, data }: Props) => {
  const allSetting = shopSelectors.data.allSetting();
  const shopInfo = shopSelectors.data.shopInfo();

  const allStaffName = data?.items?.map((item) => item.staffName).join(', ');

  return (
    <TicketBox className="ticket-detail-box" ref={divRef}>
      <HeaderStaffNameBox>
        {allStaffName}
      </HeaderStaffNameBox>
      <Row justify={'space-between'} style={{ marginTop: 5 }}>
        <TicketCodeBox>
          #{data?.ticketNumber}
        </TicketCodeBox>
        <TicketCodeBox style={{ fontSize: 30, padding: '0 16px' }}>
          {data?.appointment ? 'APPOINTMENT' : 'WALK-IN'}
        </TicketCodeBox>
        <Col>
          {data?.checkInTime && <Text style={{ wordSpacing: '0px', fontSize: '30px', fontWeight: 'bold' }}>{data?.checkInTime}</Text>}
        </Col>
      </Row>
      <Row justify={'center'} style={{ marginBottom: 8, marginTop: 10 }}>
        <ShopText printMode variant="CONTENT_2" className='bold' style={{ fontSize: '1.5rem' }}>{shopInfo?.shopName || ''}</ShopText>
      </Row>
      <Text mb={0.5} />
      {data?.qrCode && <Row align={'middle'} justify={'center'} className='container'>
        <QRCode size={200} value={data.qrCode} />
      </Row>}
      <Text mb={0.5} />
      {(data?.numberCustomers || 0) > 1 && (
        <Box display='flex' alignItems='center' mt='4'>
          <TicketCodeBox style={{ fontSize: 20, height: 36 }}>
            <img src={ic_group} alt="ic_group" style={{ width: 20, height: 20 }} />
            PARTY OF {data?.numberCustomers}
          </TicketCodeBox>
        </Box>
      )}
      <Row align={'middle'} className='container'>
        <Text style={{ fontSize: '18px', color: 'black' }} mr={0.5}>Customer: </Text>
        <ShopText printMode variant="CONTENT_2" className='bold' style={{ fontSize: '18px' }}>{data?.customerName} - {maskPhone(data?.phone || '')}</ShopText>
      </Row>
      {data?.customerHobbies && (
        <Row align={'middle'} className='container'>
          <Text style={{ fontSize: '18px', color: 'black' }} mr={0.5}>Hobbies: </Text>
          <ShopText printMode variant="CONTENT_2" className='bold' style={{ fontSize: '18px' }}>{data?.customerHobbies}</ShopText>
        </Row>
      )}
      {data?.customerHealth && (
        <Row align={'middle'} className='container'>
          <Text style={{ fontSize: '18px', color: 'black' }} mr={0.5}>Health: </Text>
          <ShopText printMode variant="CONTENT_2" className='bold' style={{ fontSize: '18px' }}>{data?.customerHealth}</ShopText>
        </Row>
      )}
      {data?.customerColor && (
        <Row align={'middle'} className='container'>
          <Text style={{ fontSize: '18px', color: 'black' }} mr={0.5}>Color: </Text>
          <ShopText printMode variant="CONTENT_2" className='bold' style={{ fontSize: '18px' }}>{data?.customerColor}</ShopText>
        </Row>
      )}
      {data?.customerNote && (
        <Row align={'middle'} className='container'>
          <Text style={{ fontSize: '18px', color: 'black' }} mr={0.5}>Note: </Text>
          <ShopText printMode variant="CONTENT_2" className='bold' style={{ fontSize: '18px' }}>{data?.customerNote}</ShopText>
        </Row>
      )}
      <Text mb={0.5} />
      <div className='container'>
        {data?.items?.map((item) => (
          !item.staffId && !item.services.length ? null :
            <div key={item.staffId + data?.ticketNumber}>
              <StaffHeaderBox>{item.staffName || 'Next Available'}</StaffHeaderBox>
              <ServiceBoxStyled style={{ marginBottom: item.services?.length === 0 ? '48px' : 0 }}>
                {item.services.map((service) => (
                  <div key={service.itemId}>
                    <SpaceBetweenBox>
                      <Text printMode variant="CONTENT_2" style={{ flex: 1 }}>
                        {service.indexWorking > 0 ? `${service.indexWorking}.` : ''}{service.itemName}
                      </Text>
                      {service.customerName &&
                        <Box display='flex' alignItems='center' gap='2' mr='4'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M7.95752 0.668091C10.3298 0.668295 12.2524 2.59163 12.2524 4.96399C12.2524 6.23362 11.7014 7.37387 10.8257 8.16028C12.9292 8.46705 14.5444 10.2783 14.5444 12.4669V13.881C14.5444 14.6821 13.8953 15.3319 13.0942 15.3322H2.90576C2.10471 15.3319 1.45557 14.6821 1.45557 13.881V12.4669C1.45557 10.3038 3.0334 8.50865 5.10107 8.17102C4.21825 7.38427 3.66165 6.23954 3.66162 4.96399C3.66162 2.5915 5.58503 0.668091 7.95752 0.668091ZM5.80811 9.36633C4.20558 9.36633 2.42236 10.8644 2.42236 12.4669V14.2208H13.5142V12.4669C13.5142 10.8644 11.7944 9.36633 10.1919 9.36633H5.80811ZM7.95752 1.87122C5.91869 1.87122 4.88721 3.39277 4.88721 4.96399C4.88726 6.53518 5.97209 8.1095 7.95752 8.1095C9.94271 8.1093 11.0747 6.53508 11.0747 4.96399C11.0747 3.39287 9.79188 1.87142 7.95752 1.87122Z" fill="#232F3E" />
                          </svg>
                          <PriceBoxStyled style={{ opacity: 1 }}>
                            <Text printMode variant="CONTENT_2">{service.customerName}</Text>
                          </PriceBoxStyled>
                        </Box>}
                      <PriceBoxStyled style={{ opacity: 1 }}>
                        <Text printMode variant="CONTENT_2">
                          {service.price > 0 && (
                            <span>{formatCurrency(service.price)}</span>
                          )}
                        </Text>
                      </PriceBoxStyled>
                    </SpaceBetweenBox>
                    {service.startTime && service.endTime && (
                      <Text variant="CONTENT_2" style={{ marginLeft: '18px', color: '#1D2129' }}>
                        {service.startTime} - {service.endTime}
                      </Text>)}
                  </div>
                ))}
              </ServiceBoxStyled>
            </div>
        ))}
      </div>
      <Text style={{ background: 'black', height: 1.5, width: '80%', margin: '0 auto', marginTop: '4rem', marginBottom: '2rem' }} />
      <Row align={'middle'} justify={'center'} className='container' style={{ marginTop: '15px' }}>
        <TicketCodeBox>
          POS Stations #{storage.station_number.get()}
        </TicketCodeBox>
      </Row>
      <Text style={{ height: '1rem', width: '100%' }} />
    </TicketBox>
  );
};

export default ReceiptUI;

const TicketBox = styled.div`
  // padding: 24px 8px 48px;
  background: #fff;
  width: 25.5rem;
  height: fit-content;
`;
const TicketCodeBox = styled.div`
  border-radius: 5px;
  background: black;
  display: flex;
  padding: 0px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #fff;

  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
const ShopText = styled(Text)`
  color: black;
  font-style: normal;
  font-family: 'Roboto', serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: right;

  &.bold {
    font-size: 0.8rem;
    font-weight: 700;
  }
`;

const StaffHeaderBox = styled.div`
  width: fit-content;
  color: #fff;
  font-family: 'Roboto', serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  text-transform: capitalize;
  background: #232F3E;
  padding: 0 4px;
`;

const ServiceBoxStyled = styled.div`
  padding: 0.5rem 0;
`;

const SpaceBetweenBox = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const PriceBoxStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const HeaderStaffNameBox = styled.div`
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
`;